import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'roma-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss'],
})
export class SettingsModalComponent {
  constructor(public dialogRef: MatDialogRef<SettingsModalComponent>) {}

  exit(): void {
    this.dialogRef.close('CANCEL-X');
  }
}
